import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  categories: null,
  subcategories: null,
  subscriptionCategories: null,
  categoryIcons: [],
  error: null,
  loading: false,
};

// Get Categories
const getCategoryStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getCategorySuccess = (state: any, action: any) => {
  return updateObject(state, {
    categories: action.categories,
    error: null,
    loading: false,
  });
};

const getCategoryFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    categories: null,
  });
};

// Get Sub-Categories
const getSubCategoryStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getSubCategorySuccess = (state: any, action: any) => {
  return updateObject(state, {
    subcategories: action.subcategories,
    error: null,
    loading: false,
  });
};

const getSubCategoryFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    subcategories: null,
  });
};

// Get Subscription Categories
const getSubscriptionCategoryStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getSubscriptionCategorySuccess = (state: any, action: any) => {
  return updateObject(state, {
    subscriptionCategories: action.categories,
    error: null,
    loading: false,
  });
};

const getSubscriptionCategoryFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    subscriptionCategories: null,
  });
};

const loadCategoryIconStart = (state: any, action: any) => {
  return updateObject(state, { error: null, loading: true });
};

const loadCategoryIconSuccess = (state: any, action: any) => {
  if (action.categoryIcon) {
    return updateObject(state, {
      categoryIcons: {
        ...state.categoryIcons,
        [action.categoryIcon?.iconId]:
          action.categoryIcon?.data,
      },
      error: null,
      loading: false,
    });
  } else {
    return updateObject(state, {
      singleProductImages: null,
      error: null,
      loading: false,
    });
  }
};

const loadCategorySuccessFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    categoryIcons: null,
  });
};

const categoryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_CATEGORY_START:
      return getCategoryStart(state, action);
    case actionTypes.GET_CATEGORY_SUCCESS:
      return getCategorySuccess(state, action);
    case actionTypes.GET_CATEGORY_FAIL:
      return getCategoryFailed(state, action);
    case actionTypes.GET_SUBCATEGORY_START:
      return getSubCategoryStart(state, action);
    case actionTypes.GET_SUBCATEGORY_SUCCESS:
      return getSubCategorySuccess(state, action);
    case actionTypes.GET_SUBCATEGORY_FAIL:
      return getSubCategoryFailed(state, action);

      case actionTypes.GET_SUBSCRIPTION_CATEGORY_START:
        return getSubscriptionCategoryStart(state);
      case actionTypes.GET_SUBSCRIPTION_CATEGORY_SUCCESS:
        return getSubscriptionCategorySuccess(state, action);
      case actionTypes.GET_SUBSCRIPTION_CATEGORY_FAIL:
        return getSubscriptionCategoryFailed(state, action);

    case actionTypes.LOAD_CATEGORY_ICON_START:
      return loadCategoryIconStart(state, action);
    case actionTypes.LOAD_CATEGORY_ICON_SUCCESS:
      return loadCategoryIconSuccess(state, action);
    case actionTypes.LOAD_CATEGORY_ICON_FAIL:
      return loadCategorySuccessFailed(state, action);
    default:
      return state;
  }
};

export default categoryReducer;
